import React from "react";
import Modal from "../generic/Modal";

interface VerifyModalProps {
    onClose: () => void; // Function to close the modal
    onShowLogin: () => void; // Function to show the login modal
    message?: string; // Optional custom message
}

const VerifyModal: React.FC<VerifyModalProps> = ({ onClose, onShowLogin, message }) => {
    return (
        <Modal onClose={onClose}>
            <div className="text-center p-4">
                <h2 className="text-lg font-semibold mb-4">Verification Required</h2>
                <p className="mb-6">{message || "Please check your email to verify your account."}</p>
                <button className={"primary w-full"} onClick={onShowLogin}>
                    Back to Login
                </button>
            </div>
        </Modal>
    );
};

export default VerifyModal;
